import { Component } from '@angular/core';
import {PricingMethods} from "../../dynabwebs/dynawebs-constants";
import {FintechService} from "../../../services/fintech.service";
import {HttpClient} from "@angular/common/http";
import {of, retry, switchMap} from "rxjs";
import {delay} from "rxjs/operators";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";

@Component({
  selector: 'app-fintech-payment-info',
  templateUrl: './fintech-payment-info.component.html',
  styleUrl: './fintech-payment-info.component.scss'
})
export class FintechPaymentInfoComponent {
    paymentInfo;
    messageColor;

    PricingMethods = PricingMethods;

    paid = false;

    constructor(public fintechService: FintechService,
                private http: HttpClient,
                private toastr: ToastrService,
                private router: Router) {
        this.fintechService.notify$.subscribe( data => {
            if (this.fintechService.data.paymentInfo != null) {
                this.paymentInfo = this.fintechService.data.paymentInfo;
                this.paid = (this.paymentInfo.status == 2);
            }
        });
    }

    canMakePayment() {
        return !this.fintechService.busy;
    }

    onMakePayment() {
        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap( payerToken => {
                const url = "https://pay.signage.me/payPendingPayment.ashx";
                const options = {token: payerToken};
                this.fintechService.setBusy(true);
                return this.http.post(url, options).pipe(
                    retry({
                        count: 5,
                        delay: (error, retryCount) => {
                            this.toastr.info(`Please wait connecting to server... (${retryCount})`, `FinTech`, { timeOut: 3000 });
                            return of(error);
                        },
                    }),
                );
            }),
            switchMap(ret => {
                const data: any = ret;
                if (data.status == false) {
                    this.toastr.error("Payment fail: " + data.warning);
                    return of("a").pipe(
                        delay(5000),
                        switchMap(a => {
                            this.fintechService.setBusy(false);
                            return of("a");
                        })
                    );
                } else {
                    this.toastr.info("Payment success");
                    this.paid = true;
                    return of("a");
                }
            }),
        );
        obs$.subscribe();
    }
}
